import {
  SHOW_MESSAGE,
  FETCH_COURSE_CONTENT_SUCCESS,
  HANDLE_REQUEST_CLOSE,
  VIEW_CONTENT,
  CLEAR_COURSE_CONTENT,
  EMPTY_COURSE_CONTENT,
  SET_NEXT_CONTENT,
  SET_PREVIOUS_CONTENT,
  SET_CURRENT_CONTENT,
  TOGGLE_AUTO_PLAY,
  SET_VIDEO_END,
  UNSET_VIDEO_END,
} from "constants/ActionTypes";
import { getLoggedInUser, isUserAuthenticated } from "../helpers/authUtils";

const INIT_STATE = {
  authUser: isUserAuthenticated() ? getLoggedInUser() : null,
  courseData: "",
  contentCreator: "",
  courseTitle: "",
  thumbnail: "",
  approved: false,
  loader: true,
  alertMessage: "",
  showMessage: false,
  showEmptyData: false,
  contentType: "",
  contentURL: "",
  parentIndex: 0,
  childIndex: 0,
  autoplay: true,
  videosCompleted: false,
  videoEnd: false,
  previousURL: "#",
  nextURL: "#",
};

export default (state = INIT_STATE, action) => {
  // console.log({action})
  switch (action.type) {
    case FETCH_COURSE_CONTENT_SUCCESS:
      const courseData = action.payload.contentData,
        contentCreator = `${action.payload.firstName} ${action.payload.surname}`,
        courseTitle = action.payload.topic;
      // console.log({courseData});
      return {
        ...state,
        courseData,
        contentCreator,
        courseTitle,
        loader: false,
        showEmptyData: false,
        alertMessage: "",
      };
    case SHOW_MESSAGE:
      return {
        ...state,
        alertMessage: action.payload,
        showMessage: true,
      };
    case HANDLE_REQUEST_CLOSE:
      return {
        ...state,
        alertMessage: "",
        showMessage: false,
      };
    case VIEW_CONTENT:
      return {
        ...state,
        contentType: action.payload.contentType,
        contentURL: action.payload.contentURL,
        videoEnd: false,
        alertMessage: "",
      };
    case CLEAR_COURSE_CONTENT:
      return INIT_STATE;
    case EMPTY_COURSE_CONTENT:
      return {
        ...state,
        showEmptyData: true,
        alertMessage: "No data",
        courseData: "",
      };
    case SET_CURRENT_CONTENT:
      // debugger
      return {
        ...state,
        parentIndex: action.payload.parentIndexC,
        childIndex: action.payload.childIndexC,
      };
    case SET_NEXT_CONTENT:
      // 
      const nextparent = state.courseData[state.parentIndex];
      // console.log({nextparent})
      if (typeof nextparent !== "undefined") {
        const children = nextparent.sectionContent;
        // console.log({children})
        const nextChild =
          typeof children[state.childIndex + 1] !== "undefined"
            ? children[++state.childIndex]
            : undefined;
        if (typeof nextChild !== "undefined") {
          // console.log({nextChild})
          return {
            ...state,
            nextURL: `${
              state.courseData[state.parentIndex]["sectionContent"][
                state.childIndex + 1
              ]["contentId"]
            }`,
          };
        } else {
          const newParent =
            typeof state.courseData[state.parentIndex + 1] !== "undefined"
              ? state.courseData[state.parentIndex + 1]
              : undefined;
          if (typeof newParent !== "undefined") {
            // console.log({newParent})
            return {
              ...state,
              nextURL: `${
                state.courseData[state.parentIndex + 1]["sectionContent"][
                  INIT_STATE.childIndex
                ]["contentId"]
              }`,
            };
          } else {
            return {
              ...state,
              videosCompleted: true,
              nextURL: INIT_STATE.nextURL,
            };
          }
        }
      }
      return {
        ...state,
        nextURL: INIT_STATE.nextURL,
      };
    case SET_PREVIOUS_CONTENT:
      // debugger
      const previousParent = state.courseData[state.parentIndex];
      // console.log({previousParent})
      if (typeof previousParent !== "undefined") {
        const children = previousParent.sectionContent;
        // console.log({children})
        const nextChild =
          typeof children[state.childIndex - 1] !== "undefined"
            ? children[state.childIndex - 1]
            : undefined;
        if (typeof nextChild !== "undefined") {
          //console.log({nextChild})
          // 
          return {
            ...state,
            previousURL: `${
              state.courseData[state.parentIndex]["sectionContent"][
                state.childIndex - 1
              ]["contentId"]
            }`,
          };
        } else {
          const newParent =
            typeof state.courseData[state.parentIndex - 1] !== "undefined"
              ? state.courseData[state.parentIndex - 1]
              : undefined;
          if (typeof newParent !== "undefined") {
            // console.log({newParent})
            return {
              ...state,
              previousURL: `${
                state.courseData[state.parentIndex - 1]["sectionContent"][
                  INIT_STATE.childIndex
                ]["contentId"]
              }`,
            };
          } else {
            return {
              ...state,
              previousURL: INIT_STATE.previousURL,
            };
          }
        }
      }
      return {
        ...state,
        previousURL: INIT_STATE.previousURL,
      };
    case TOGGLE_AUTO_PLAY:
      return {
        ...state,
        autoplay: !state.autoplay,
      };
    case SET_VIDEO_END:
      // debugger
      return {
        ...state,
        alertMessage: `Video has ended, go to next lesson`,
        videoEnd: true,
      };

    case UNSET_VIDEO_END:
      // 
      return {
        ...state,
        alertMessage: ``,
        videoEnd: false,
      };
    default:
      return state;
  }
};
